import ReadMoreButton from "../../../../../components/buttons/readMoreButton/readMoreButton";
import "./heroSectionItemStyle.css"
import { useEffect, useState } from "react";

export default function HeroSectionItem({photo, catchPhrase, url}) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    };

    useEffect( () => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    if (windowWidth < 1025)
        return (
            <div className="hero-section-item__container" >
                <div className="hero-section-item__catchy-phrase-container">
                    <img className="hero-section-item__catchy-phrase" src={catchPhrase} />
                </div>
                <div className="hero-section-item__photo-container">
                    <img className="hero-section-item__photo" src={photo} />
                </div>
            </div>
        );

    return (
        <div className="hero-section-item__container" >
            <div className="hero-section-item__catchy-phrase-container">
                <img className="hero-section-item__catchy-phrase" src={catchPhrase} />
            </div>
            <div className="hero-section-item__photo-container">
                <img className="hero-section-item__photo" src={photo} />
            </div>
        </div>
    );
}